import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    OnePageCheckUpdateInfoParameter,
    updateContactInfo,
} from "@sunSource/Services/OnePageCheckoutUpdateContactInfoService";

type HandlerType = ApiHandler<OnePageCheckUpdateInfoParameter, any>;

export const PostUserUpdateData: HandlerType = async props => {
    try {
        const result = await updateContactInfo(props.parameter);
        props.apiResult = {
            success: true,
        };
    } catch (err) {
        props.apiResult = {
            success: false,
        };
    }
};

const userUpdateChain = [PostUserUpdateData];

const updateUserContactInfo = createHandlerChainRunner(userUpdateChain, "UpdateUserContactInfo");
export default updateUserContactInfo;
